import React from 'react';
import { Instagram, Facebook, Twitter } from 'lucide-react';
export function Footer() {
  return <footer className="bg-background py-16 border-t border-divider" data-id="element-97">
      <div className="container mx-auto px-4 md:px-8 flex flex-col items-center text-center" data-id="element-98">
        <a href="#" className="font-serif text-2xl font-medium tracking-tight text-foreground mb-8" data-id="element-99">
          Be Clinical
        </a>

        <div className="flex space-x-6 mb-12 text-foreground/60" data-id="element-100">
          <a href="#" className="hover:text-gold transition-colors" aria-label="Instagram" data-id="element-101">
            <Instagram size={20} data-id="element-102" />
          </a>
          <a href="#" className="hover:text-gold transition-colors" aria-label="Facebook" data-id="element-103">
            <Facebook size={20} data-id="element-104" />
          </a>
          <a href="#" className="hover:text-gold transition-colors" aria-label="Twitter" data-id="element-105">
            <Twitter size={20} data-id="element-106" />
          </a>
        </div>

        <div className="text-foreground/50 font-sans text-sm space-y-2" data-id="element-107">
          <p data-id="element-108">123 Medical Plaza, Suite 400, San Ramon, CA 94583</p>
          <p data-id="element-109">
            &copy; {new Date().getFullYear()} Be Clinical. All rights reserved.
          </p>
        </div>
      </div>
    </footer>;
}